export default __webpack_public_path__ + "static/media/info.63255596.png";